export default __webpack_public_path__ + "static/media/icon-calendar-xl.e50e385f.svg";